import baseMigrate from "@Shared/Entities/AbstractEntities/BaseEntity/migrate";
const version1 = (current = {}) => {
    const { version = 0 } = current;
    if (version >= 1) {
        return current;
    }
    return { ...current, version: 1 };
};
export default (original = {}) => {
    const baseMigrated = baseMigrate(original);
    const converted = [version1].reduce((converted, f) => f(converted), original);
    const { name, ref, username, password, platform } = converted;
    return {
        ...baseMigrated,
        name,
        ref,
        username,
        password,
        platform,
    };
};
